import { FC } from 'react';
import { Button } from '@ebsco-ui/ebsco-ui';

import { useAuthPageWrapperContext } from '../AuthPageWrapperContext';

interface SubmitButtonProps {
  isDisabled?: boolean;
}

export const SubmitButton: FC<SubmitButtonProps> = ({
  isDisabled = false,
  children,
}) => {
  const { cnBem } = useAuthPageWrapperContext();

  return (
    <Button
      className={cnBem('__submitButton')}
      styleType="solid"
      type="submit"
      disabled={isDisabled}
    >
      {children}
    </Button>
  );
};
